module.exports = __webpack_public_path__ + "static/media/04-antonio-carlos.73c2d8ea.webp";